import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./contexts/userContext";
import LandingPage from "./components/landingPage"; // Importa el componente LandingPage
import AppPage from "./components/appPage"; // Importa el componente AppPage (contiene tu actual App.js)
import EventoDetalle from "./components/EventoDetalle";
import PdfPage from "./components/pdfPage";

const TERMINOS_PDF =
  "/docs/PICALA_Terminos_y_Condiciones_MVP_2026-10-18.pdf";
const PRIVACIDAD_PDF =
  "/docs/PICALA_Politica_de_Privacidad_MVP_2026-10-18.pdf";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <UserProvider>
      <Router>
        <Routes>
          {/* Ruta principal para la Landing Page */}
          <Route path="/" element={<LandingPage />} />
          {/* Ruta para la aplicación */}
          <Route path="/app" element={<AppPage />} />
          <Route path="/app/eventos/:eventId" element={<EventoDetalle />} />
          <Route
            path="/picala/tyc"
            element={
              <PdfPage file={TERMINOS_PDF} title="Términos y Condiciones" />
            }
          />
          <Route
            path="/picala/privacidad"
            element={
              <PdfPage
                file={PRIVACIDAD_PDF}
                title="Política de Privacidad"
              />
            }
          />
        </Routes>
      </Router>
    </UserProvider>
  </React.StrictMode>
);

// Para medir rendimiento
reportWebVitals();
